import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import {
  attachBootVideoEnded,
  getBootSplashRoot,
} from '../../utils/bootSplash';
import styles from '../../styles/Preloader.module.scss';

const GaugePanel = ({ message }) => (
  <div className={styles.panel}>
    <div className={styles.gaugeWrap} aria-hidden="true">
      <div className={styles.gaugeRing}>
        <div className={styles.gaugeTicks} />
        <div className={styles.gaugeNeedle} />
        <div className={styles.gaugeHub} />
      </div>
      <div className={styles.wheel}>
        <div className={styles.wheelRim} />
        <div className={styles.wheelSpokes} />
      </div>
    </div>

    <div className={styles.statusRow}>
      <span className={styles.statusDot} />
      <span className={styles.statusText}>Check Engine</span>
    </div>

    <p className={styles.message}>{message}</p>

    <div className={styles.fuelTrack} aria-hidden="true">
      <div className={styles.fuelFill} />
      <span className={styles.fuelLabel}>E</span>
      <span className={styles.fuelLabelEnd}>F</span>
    </div>
  </div>
);

const BootVideoSplash = ({ onVideoEnded, onSkip }) => {
  const [mountNode, setMountNode] = useState(null);

  useEffect(() => {
    setMountNode(getBootSplashRoot());
  }, []);

  useEffect(() => attachBootVideoEnded(onVideoEnded), [onVideoEnded]);

  const skipButton = onSkip ? (
    <button type="button" className="boot-splash-skip" onClick={onSkip}>
      Пропустити
    </button>
  ) : null;

  if (mountNode && skipButton) {
    return createPortal(skipButton, mountNode);
  }

  return null;
};

const Preloader = ({
  fullScreen = false,
  exiting = false,
  message = 'Завантаження…',
  className = '',
  onSkip,
  onVideoEnded,
  videoSplash = false,
}) => {
  if (fullScreen && videoSplash) {
    return <BootVideoSplash onVideoEnded={onVideoEnded} onSkip={onSkip} />;
  }

  const rootClass = [
    styles.preloader,
    fullScreen ? styles.fullScreen : styles.inline,
    exiting ? styles.exiting : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={rootClass} role="status" aria-live="polite" aria-label={message}>
      <GaugePanel message={message} />
    </div>
  );
};

export default Preloader;
